// --------------------------------------------------------------------------
// 자동결제해지 사용자 조회 상태
// --------------------------------------------------------------------------
export const PROMOTION_100_WON_OFFER = '100WON_PROMOTION_OFFER'
export const PROMOTION_50_PERCENT_OFFER = '50PERCENT_PROMOTION_OFFER'
export const PROMOTION_10000_COIN_OFFER = '10000COIN_PROMOTION_OFFER'
export const NO_OFFER = 'NO_OFFER'
export const ALREADY_RECEIVE = 'ALREADY_RECEIVE'
export const CANNOT_CANCEL = 'CANNOT_CANCEL'
export const AOS_10000COIN_PROMOTION_OFFER = 'AOS_10000COIN_PROMOTION_OFFER'
export const AOS_ALREADY_RECEIVE = 'AOS_ALREADY_RECEIVE'
export const AOS_NO_OFFER = 'AOS_NO_OFFER'

// --------------------------------------------------------------------------
// 해지취소 사용자 상태
// --------------------------------------------------------------------------
export const CANCEL_COMPLETE = 'CANCEL_COMPLETE'
export const RECEIVE_PROMOTION = 'RECEIVE_PROMOTION'
export const DEFENSE_COIN = 'DEFENSE_COIN'

// --------------------------------------------------------------------------
// 자동결제해지, 해지취소
// --------------------------------------------------------------------------
export const UNSUBSCRIBE = 'unsubscribe'
export const UNSUBSCRIBE_CANCEL = 'unsubscribe-cancel'

// --------------------------------------------------------------------------
// 프로모션 제공 팝업
// --------------------------------------------------------------------------
const AOS_COMMON_HEADER_TEXT = `<strong>웨이브 이용권을 유지</strong>하시면<br />다음 이용권 결제 7일 이내<strong> 10,000 코인을 드려요</strong><span class="coin-text">이용권을 유지하시겠습니까?</span><span class="footer-text">* 웨이브 코인은 영화나 방송 VOD 단건 구매에 사용하실 수 있습니다.</span>`
export const PROMOTION_HEADER_TEXT = {
  '10000COIN_PROMOTION_OFFER': {
    html: '<strong>웨이브 이용권을 유지</strong>하시면<br />즉시 사용할 수 있는 <strong>10,000코인</strong>을 드려요<br /><span class="coin-text">이용권을 유지하시겠습니까?</span><span class="footer-text">* 웨이브 코인은 영화나 방송 VOD 단건 구매에 사용하실 수 있습니다.</span>',
  },
  DEFENSE_COIN: {
    html: '<strong>웨이브 이용권을 해지 취소</strong>하시면<br/>즉시 사용할 수 있는 <strong>10,000 코인을 드려요.</strong><br /><span class="coin-text">이용권을 다시 이용하시겠습니까?</span><span class="footer-text">* 웨이브 코인은 영화나 방송 VOD 단건 구매에 사용하실 수 있습니다.</span>',
  },
  NO_OFFER: {
    html: '지금 해지하시면<strong> 매주 업데이트 되는</strong><br /><strong>다양한 영화와 프로그램</strong>들을 더 이상 볼 수 없어요!<br /><span class="coin-text">정말 해지하시겠어요?</span>',
  },
  '50PERCENT_PROMOTION_OFFER': {
    html: '<strong>웨이브 이용권을 유지</strong>하시면<br />한 달 간 웨이브를<br /><strong>50% 할인된 가격에 이용</strong>하실 수 있어요!<br /><span class="coin-text">이용권을 유지하시겠습니까?</span>',
  },
  '100WON_PROMOTION_OFFER': {
    html: '<strong>웨이브 이용권을 유지</strong>하시면<br />한 달 간 웨이브를<br /><strong>100원에 이용</strong>하실 수 있어요!<br /><span class="coin-text">이용권을 유지하시겠습니까?</span>',
  },
  AOS_NO_OFFER: {
    html: AOS_COMMON_HEADER_TEXT,
  },
  AOS_10000COIN_PROMOTION_OFFER: {
    html: AOS_COMMON_HEADER_TEXT,
  },
  default: {
    html: '',
  },
}
const PROMOTION_10000_COMMON_HEADER_IMAGE_INFO = {
  src: require('@/assets/images/revocation-defense/10000-coin-banner.png'),
  alt: '10,000 코인 프로모션 배너',
}
export const PROMOTION_HEADER_IMAGE_INFO = {
  '50PERCENT_PROMOTION_OFFER': {
    src: require('@/assets/images/revocation-defense/50-percent-promotion-banner.png'),
    alt: '50% 할인 프로모션 배너',
  },
  '100WON_PROMOTION_OFFER': {
    src: require('@/assets/images/revocation-defense/100-won-promotion-banner.png'),
    alt: '100원 프로모션 배너',
  },
  NO_OFFER: {
    src: require('@/assets/images/revocation-defense/ico-ticket.png'),
    alt: '티켓 아이콘',
  },
  '10000COIN_PROMOTION_OFFER': PROMOTION_10000_COMMON_HEADER_IMAGE_INFO,
  AOS_10000COIN_PROMOTION_OFFER: PROMOTION_10000_COMMON_HEADER_IMAGE_INFO,
  AOS_NO_OFFER: PROMOTION_10000_COMMON_HEADER_IMAGE_INFO,
  DEFENSE_COIN: PROMOTION_10000_COMMON_HEADER_IMAGE_INFO,
}

export const POPUP_BUTTON_ACTION_TYPE = {
  SYSTEM: 'SYSTEM',
  LAYER: 'LAYER',
  CLOSE: 'CLOSE',
}
const AOS_COMMON_PROMOTION_BUTTON_INFO = {
  primaryText: '10,000 코인 받고 이용권 유지',
  grayText: '자동결제 해지 및 구독관리',
  primaryAction: POPUP_BUTTON_ACTION_TYPE.LAYER,
  grayAction: POPUP_BUTTON_ACTION_TYPE.SYSTEM,
}
export const PROMOTION_BUTTON_INFO = {
  '10000COIN_PROMOTION_OFFER': {
    primaryText: '10,000 코인 받고 이용권 유지',
    grayText: '자동결제 해지',
    primaryAction: POPUP_BUTTON_ACTION_TYPE.LAYER,
    grayAction: POPUP_BUTTON_ACTION_TYPE.SYSTEM,
  },
  DEFENSE_COIN: {
    primaryText: '10,000 코인 받고 자동결제 해지 취소',
    grayText: '자동결제 해지 유지',
    primaryAction: POPUP_BUTTON_ACTION_TYPE.LAYER,
    grayAction: POPUP_BUTTON_ACTION_TYPE.CLOSE,
  },
  '50PERCENT_PROMOTION_OFFER': {
    primaryText: '다음달 50% 할인 받고 이용권 유지',
    grayText: '자동결제 해지',
    primaryAction: POPUP_BUTTON_ACTION_TYPE.LAYER,
    grayAction: POPUP_BUTTON_ACTION_TYPE.SYSTEM,
  },
  '100WON_PROMOTION_OFFER': {
    primaryText: '다음달 100원 혜택 받고 이용권 유지',
    grayText: '자동결제 해지',
    primaryAction: POPUP_BUTTON_ACTION_TYPE.LAYER,
    grayAction: POPUP_BUTTON_ACTION_TYPE.SYSTEM,
  },
  NO_OFFER: {
    primaryText: '이용권 유지',
    grayText: '자동결제 해지',
    primaryAction: POPUP_BUTTON_ACTION_TYPE.CLOSE,
    grayAction: POPUP_BUTTON_ACTION_TYPE.SYSTEM,
  },
  AOS_NO_OFFER: AOS_COMMON_PROMOTION_BUTTON_INFO,
  AOS_10000COIN_PROMOTION_OFFER: AOS_COMMON_PROMOTION_BUTTON_INFO,
}
const PROMOTION_10000_COMMON_NOTICE_LIST = [
  '보너스 코인을 사용한 경우 전자상거래법 등 관련 법률에 따라 해지 신청이 제한될 수 있습니다.',
  '코인 수령 시 32일 이후 해지 신청이 가능하며 코인을 사용하지 않은 경우 고객센터를 통해 해지 신청을 요청 할 수 있습니다.',
]
const AOS_COMMON_NOTICE_LIST = ({ date }) => [
  `자동 결제 후 5일 전(${date})까지 이용권을 해지하거나 환불하시면, 10,000코인 혜택은 제공되지 않습니다.`,
  '보너스 코인을 사용한 경우 전자상거래법 등 관련 법률에 따라 해지 신청이 제한될 수 있습니다.',
]

export const PROMOTION_NOTICE_LIST = {
  DEFENSE_COIN: [
    '해당 프로모션은 고객님께만 적용되는 혜택으로, 자동결제 해지 취소 버튼을 클릭 해주셔야 적용 가능합니다.',
  ].concat(PROMOTION_10000_COMMON_NOTICE_LIST),
  '10000COIN_PROMOTION_OFFER': [
    '해당 프로모션은 고객님께만 적용되는 혜택으로, 이용권 유지 버튼을 클릭 해주셔야 적용 가능합니다.',
  ].concat(PROMOTION_10000_COMMON_NOTICE_LIST),
  '50PERCENT_PROMOTION_OFFER': [
    '해당 프로모션은 고객님께만 적용되는 혜택으로, 이용권 유지 버튼을 클릭 해주셔야 적용 가능합니다.',
    '50% 할인 자동결제 전 이용권 변경, 환불 또는 자동결제 해지 시, 50% 할인 혜택이 제공되지 않습니다.',
    `'유료상품이용약관'에 따라 구독을 해지하거나 이용권을 변경하실 수 있습니다.`,
  ],
  '100WON_PROMOTION_OFFER': [
    '해당 프로모션은 고객님께만 적용되는 혜택으로, 이용권 유지 버튼을 클릭 해주셔야 적용 가능합니다.',
    '100원 자동결제 전 이용권 변경, 환불 또는 자동결제 해지 시, 100원 혜택이 제공되지 않습니다.',
    `'유료상품이용약관'에 따라 구독을 해지하거나 이용권을 변경하실 수 있습니다.`,
  ],
  AOS_10000COIN_PROMOTION_OFFER: AOS_COMMON_NOTICE_LIST,
  AOS_NO_OFFER: AOS_COMMON_NOTICE_LIST,
  default: [],
}
const EXPIRE_DATE = {
  TEXT: '만료일자',
  DATE: 'endDate',
}
const PAY_DATE = {
  TEXT: '결제일자',
  DATE: 'startDate',
}
export const PROMOTION_DATE_INFO = {
  '100WON_PROMOTION_OFFER': EXPIRE_DATE,
  '50PERCENT_PROMOTION_OFFER': EXPIRE_DATE,
  '10000COIN_PROMOTION_OFFER': EXPIRE_DATE,
  NO_OFFER: EXPIRE_DATE,
  AOS_10000COIN_PROMOTION_OFFER: PAY_DATE,
  DEFENSE_COIN: PAY_DATE,
}

// --------------------------------------------------------------------------
// 자동 결제 해지, 이용권 변경 프로모션 제외 경고 레이어팝업 메세지
// --------------------------------------------------------------------------
export const WARNING_LAYER_POPUP_INFO = {
  PROMOTION_CANCEL: {
    TITLE: ({ promotionTitle = '' }) =>
      `지금 자동결제를 해지하시면,\n${promotionTitle} 프로모션을 이용할 수 없습니다.`,
    DESCRIPTION: ({ promotionTitle = '' }) =>
      `고객님은 현재 ${promotionTitle} 프로모션 혜택 대상자입니다.\n이용권 자동결제를 해지하시면, 혜택을 받을 수 없습니다.\n<span class="spaced-block">자동 결제를 해지 하시겠습니까?</span>`,
    GRAY_BUTTON_TEXT: '자동결제 해지',
    PRIMARY_BUTTON_TEXT: '자동결제 유지',
  },
  VOUCHER_CHANGE: {
    TITLE: ({ promotionTitle = '' }) =>
      `지금 이용권을 변경하시면,\n${promotionTitle} 프로모션을 이용할 수 없습니다.`,
    DESCRIPTION: ({ promotionTitle = '' }) =>
      `고객님은 현재 ${promotionTitle} 프로모션 혜택 대상자입니다.\n이용권 변경하시면, 혜택을 받을 수 없습니다.\n<span class="spaced-block">이용권을 변경하시겠습니까?</span>`,
    GRAY_BUTTON_TEXT: '이용권 변경',
    PRIMARY_BUTTON_TEXT: '이용권 유지',
  },
}

// --------------------------------------------------------------------------
// 프로모션, 이용권 유지 레이어 팝업 메시지
// --------------------------------------------------------------------------
const AOS_REWARD_PROMOTION_POPUP_MESSAGE = {
  TITLE: '감사합니다.',
  DESCRIPTION: () =>
    '다음 이용권 결제 7일 이내에 코인이 지급됩니다.<br/>보너스 코인은 <span class="text-emphasis" style="color: white">MY > 코인내역</span>에서 확인하실 수 있습니다.',
  NOTICE_LIST: [
    '웨이브 코인은 영화 단건 구매나 방송 VOD 단건 구매로 사용하실 수 있습니다.',
    '다음 결제일에 이용권이 정상결제되며, 다음 결제일 5일 뒤에 코인이 지급됩니다.',
    '보너스 코인을 사용한 경우 전자상거래법 등 관련 법률에 따라 해지 신청이 제한될 수 있습니다.',
  ],
  CONFIRM_TEXT: '확인',
}
const PROMOTION_10000_KEEP_POPUP_MESSAGE = {
  TITLE: '감사합니다.',
  DESCRIPTION: () =>
    '10,000 코인이 지급되었습니다. \n보너스 코인은 <span class="text-emphasis" style="color: white">MY > 코인내역</span>에서 확인하실 수 있습니다.',
  NOTICE_LIST: [
    '웨이브 코인은 영화 단건 구매나 방송 VOD 단건 구매로 사용하실 수 있습니다.',
    '다음 결제일에 이용권이 정상결제됩니다.',
    '보너스 코인을 사용한 경우 전자상거래법 등 관련 법률에 따라 해지 신청이 제한될 수 있습니다.',
  ],
  CONFIRM_TEXT: '확인',
}

export const REWARD_PROMOTION_POPUP_MESSAGE = {
  '100WON_PROMOTION_OFFER': {
    TITLE: '감사합니다.',
    DESCRIPTION: ({ title, date, price }) =>
      `${title} 이용권은 ${date}에 ${price}원 결제 후,\n이후부터 정상 요금이 정기 결제됩니다.\n이용권 내역은 <span class="text-emphasis" style="color: white">MY > 나의 이용권</span>에서 확인하실 수 있습니다.`,
    NOTICE_LIST: [
      '100원 자동결제 전 이용권 변경, 환불 또는 자동결제 해지 시, 100원 혜택이 제공되지 않습니다.',
      `'유료상품이용약관'에 따라 구독을 해지하거나 이용권을 변경하실 수 있습니다.`,
    ],
    CONFIRM_TEXT: '확인',
  },
  '50PERCENT_PROMOTION_OFFER': {
    TITLE: '감사합니다.',
    DESCRIPTION: ({ title, date, price }) =>
      `${title} 이용권은 ${date}에 ${price}원 결제 후,\n이후부터 정상 요금이 정기 결제됩니다.\n이용권 내역은 <span class="text-emphasis" style="color: white">MY > 나의 이용권</span>에서 확인하실 수 있습니다.`,
    NOTICE_LIST: [
      '50% 자동결제 전 이용권 변경, 환불 또는 자동결제 해지 시, 반 값 혜택이 제공되지 않습니다.',
      `'유료상품이용약관'에 따라 구독을 해지하거나 이용권을 변경하실 수 있습니다.`,
    ],
    CONFIRM_TEXT: '확인',
  },
  '10000COIN_PROMOTION_OFFER': PROMOTION_10000_KEEP_POPUP_MESSAGE,
  DEFENSE_COIN: PROMOTION_10000_KEEP_POPUP_MESSAGE,
  AOS_10000COIN_PROMOTION_OFFER: AOS_REWARD_PROMOTION_POPUP_MESSAGE,
  AOS_NO_OFFER: AOS_REWARD_PROMOTION_POPUP_MESSAGE,
}
export const PROMOTION_REVOCATION_CANCEL_POPUP_INFO = {
  TITLE: '감사합니다.',
  DESCRIPTION: '자동결제 해지가 취소 되었습니다.',
  CONFIRM_TEXT: '확인',
}
// --------------------------------------------------------------------------
// 시스템 팝업 문구
// --------------------------------------------------------------------------
export const PROMOTION_REVOCATION_POPUP_MESSAGE =
  '자동결제가 해지되었습니다.\n자동결제를 다시 유지하고 싶으신 경우\n이용권 만료일 하루 전까지\n[자동결제 해지 취소]가 가능합니다.'
export const GOOGLE_PROMOTION_JOIN_INFO_POPUP_MESSAGE =
  '구글 플레이에서 구매한 이용권은 구글 플레이에\n서만 해지할 수 있으며, 해지 시 10,000 코인 프로모션은 제공되지 않습니다. \n\n구글 플레이 결제 페이지로 이동합니다.'
export const PROMOTION_ALREADY_RECEIVE_POPUP_MESSAGE =
  '자동결제 해지신청은 [자동결제 유지 이벤트]\n코인이 만료 다음날부터 가능합니다.(코인은\n지급일 기준 32일 후 만료)'
export const AOS_PROMOTION_NO_OFFER_POPUP_MESSAGE =
  'Google 앱 내 구매 이용권은 Google play\n페이지에서만 해지 / 해지취소가 가능합니다.\nGoogle play 페이지로 이동합니다.'
// --------------------------------------------------------------------------
// 메인 팝업 해지방어
// --------------------------------------------------------------------------
export const SYSTEM_ERROR_MESSAGE = `정상 처리되지 않았습니다.\n나중에 다시 시도해주세요.`
